import isTableConfig from 'notebook/structured-tables/util/isTableConfig';
import {StructuredTableToTableMetadata, Table} from 'notebook/tables/TableConstants';
import APIUtil from 'util/APIUtil';

/**
 * Computes whether the given table is a table in config mode in a template.
 */
export function computeIsConfigTable(table: Table): boolean {
  const metadata = table.metadata as StructuredTableToTableMetadata<unknown>;
  return (
    metadata?.isConfig ||
    isTableConfig(table._tableType) ||
    Boolean(table.fileId && APIUtil.isConfigurationDocument(table.fileId))
  );
}
